import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';

import '../../../assets/styles/SideBar.css';
import Indices from '../indices';
import SubscriptionWidget from '../subscriptionWidget';
import Routes from '../../../constants/routes';
import { YOUTUBE_CHANNEL_URL, YOUTUBE_WIDGET_VIDEO_URL, WHATS_APP_URL } from '../../../constants/globals';
import AUDIO from '../../../assets/images/widgets/audio-fatwas.webp';
import ASK_QUESTION from '../../../assets/images/widgets/ask-question.webp';
import HADITH_DARS from '../../../assets/images/widgets/hadith-dars.webp';
import RESEARCH from '../../../assets/images/widgets/research.webp';
import AFFILIATED_SITES from '../../../assets/images/widgets/affiliated-sites.webp';
import INDICES from '../../../assets/images/widgets/indices.webp';
import WHATSAPP from '../../../assets/images/widgets/whatsapp.webp';

class SideBar extends Component {
    componentDidMount() {
        if (!window.twttr) {
            const script = document.createElement('script');
            script.src = 'https://platform.twitter.com/widgets.js';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }
    }

    render() {
        const { pathname } = this.props;

        return (
            <div className="side-bar">
                <div id="social-4" className="social-icons-widget">
                    <div className="widget-top" />
                    <div className="widget widget-container">
                        <div className="social-icons social-colored">
                            <a
                                className="ttip-none rss-links"
                                title="Rss"
                                href="http://ciiradio.com/category/qa/"
                                rel="noreferrer noopener"
                                target="_blank"
                            >
                                <i
                                    className="fa fa-rss"
                                />
                            </a>
                            <a
                                className="ttip-none youtube-link"
                                title="Youtube"
                                href={YOUTUBE_CHANNEL_URL}
                                rel="noreferrer noopener"
                                target="_blank"
                            >
                                <i
                                    className="fa fa-youtube"
                                />
                            </a>
                            <a
                                className="ttip-none instagram-link"
                                title="instagram"
                                href="https://www.instagram.com/theidealwoman_org/"
                                rel="noreferrer noopener"
                                target="_blank"
                            >
                                <i
                                    className="fa fa-instagram"
                                />
                            </a>
                            <a
                                className="ttip-none paypal-link"
                                title="paypal"
                                href="https://www.paypal.com/donate/?cmd=_s-xclick&hosted_button_id=H5Y5N45UE3QQY&source=url"
                                rel="noreferrer noopener"
                                target="_blank"
                            >
                                <i
                                    className="fa fa-paypal"
                                />
                            </a>
                            <a
                                className="ttip-none"
                                title="whatsapp"
                                href={WHATS_APP_URL}
                                rel="noreferrer noopener"
                                target="_blank"
                            >
                                <i
                                    className="fa fa-whatsapp"
                                />
                            </a>
                        </div>

                    </div>
                </div>
                <div>
                    <Link to={Routes.darulIftaa}>
                        <LazyLoad>
                            <img
                                className="side-bar-image"
                                src={ASK_QUESTION}
                                alt="Submit Question"
                            />
                        </LazyLoad>
                    </Link>
                </div>
                <div style={{ marginBottom: '20px', width: '100%' }}>
                    <LazyLoad>
                        <iframe
                            title="Mufti Ebrahim Desai"
                            height="400"
                            src={YOUTUBE_WIDGET_VIDEO_URL}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            frameBorder="0"
                            allowFullScreen
                            style={{ width: '100%' }}
                        />
                    </LazyLoad>
                </div>
                <SubscriptionWidget />
                <div>
                    <Link to={Routes.hadiths}>
                        <LazyLoad>
                            <img className="side-bar-image" src={HADITH_DARS} alt="Hadiths" />
                        </LazyLoad>
                    </Link>
                </div>
                <div>
                    <Link to={Routes.audioList}>
                        <LazyLoad>
                            <img
                                className="side-bar-image"
                                src={AUDIO}
                                alt="Ask a Question"
                            />
                        </LazyLoad>
                    </Link>
                </div>
                <div>
                    <Link to={Routes.researches}>
                        <LazyLoad>
                            <img
                                className="side-bar-image"
                                src={RESEARCH}
                                alt="Research"
                            />
                        </LazyLoad>
                    </Link>
                </div>
                {
                    pathname === Routes.home &&
                    <div>
                        <Link to={Routes.indices}>
                            <LazyLoad>
                                <img
                                    className="side-bar-image-indices"
                                    src={INDICES}
                                    alt="Indices"
                                />
                            </LazyLoad>
                        </Link>
                        <Indices />
                    </div>
                }
                <div>
                    <a href="https://darulmahmood.net/category/dars-hadith/" target="_blank" rel="noopener noreferrer">
                        <LazyLoad>
                            <img
                                className="side-bar-image"
                                src={HADITH_DARS}
                                alt="Ask a Question"
                            />
                        </LazyLoad>
                    </a>
                </div>
                <div>
                    <Link to={Routes.darulIftaa}>
                        <LazyLoad>
                            <img className="side-bar-image" src={AFFILIATED_SITES} alt="Affiliated" />
                        </LazyLoad>
                    </Link>
                </div>
                <div>
                    <a href={WHATS_APP_URL} target="_blank" rel="noopener noreferrer">
                        <LazyLoad>
                            <img
                                className="side-bar-image"
                                src={WHATSAPP}
                                alt="Ask a Question"
                            />
                        </LazyLoad>
                    </a>
                </div>
                <div>
                    <LazyLoad>
                        <a
                            className="twitter-timeline"
                            href="https://twitter.com/MuftiEbrahim?ref_src=twsrc%5Etfw"
                            data-dnt="true"
                            data-height="350"
                            data-tweet-limit="1"
                        >
                            Tweets by MuftiEbrahim
                        </a>
                    </LazyLoad>
                </div>
            </div>
        );
    }
}

SideBar.propTypes = {
    pathname: PropTypes.string.isRequired,
};

export default SideBar;
